/**
 * How a company's registration number is shown to staff or the owner on a screen that identifies
 * the company (specs/skattekonto-flow-gaps D8). A sole trader's number is the owner's personnummer,
 * so its last four digits are hidden (`YYMMDD-****`); an organisation's number is public and shown
 * as given. The shape decides: the third digit of the 10-digit form is 0 or 1 (a month) for a
 * personnummer or samordningsnummer and 2 or more for an organisation. Anything else is masked.
 */
export function displayOrganizationNumber(value: string | null | undefined): string {
  const digits = (value ?? "").replace(/\D/g, "");
  if (digits.length !== 10 && digits.length !== 12) return "****";
  const ten = digits.slice(-10);
  if (Number(ten[2]) >= 2) return value as string;
  return `${digits.slice(0, -4)}-****`;
}
